module.exports = __webpack_public_path__ + "img/graph.a9f85f37.svg";